export default function () {
  return {
    currencies: [],
    languages: [],
    paymentTypes: [],
    currentCurrency: null,
    currentLanguage: null
  };
}
